module.exports = __webpack_public_path__ + "img/spinosaLogo2.5f1bd984.png";